export default "__VITE_ASSET__BNFHM9o7__"